import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'yo-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.scss'],
    standalone: false
})
export class FeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
